<!-- =========================================================================================
  File Name: LeaderboardList.vue
  Description: Leaderboard List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <h3 class="mr-3">Leader Board</h3>
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  ListData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : ListData.length
                }}
                of {{ ListData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!--ADD Leaderboard-->
        <vs-button v-on:click="getHideInLeaderboard">Hide In Leaderboard</vs-button>
        <vs-button v-on:click="attendessList=[];popupUserList = true" class="ml-3">Clear Score</vs-button>
        <vs-button
          color="primary"
          type="border"
          class="ml-3 mr-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
        <vx-tooltip text="Actions" position="bottom">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-3
                shadow-drop
                rounded-lg
                d-theme-dark-light-bg
                cursor-pointer
                flex
                items-end
                justify-center
                text-lg
                font-medium
                w-32
              "
            >
              <span class="leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu class="dropdown-width">
              <vs-dropdown-item @click="exportAllUsers">
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Export All Users Scores</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="exportAllActions">
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Export All Actions Scroes</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="popupActive2 = true">
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Create Custom Activity</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="openManualScoreUploadModal()">
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Upload Scores Manually</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vx-tooltip>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="ListData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <vs-popup
      class="holamundo leader-board-settings"
      title="Leaderboard Settings"
      :active.sync="popupActive"
    >
      <div class="leaderboard-settings-wrap">
        <ul>
          <li class="mb-3">
            <div class="single-settings">
              <div class="setting-left">
                <label>Display Leaderboard Score On Menu Profile</label>
              </div>
              <div class="setting-action">
                <vs-switch v-model="settings.DisplayScoreOnProfile" />
              </div>
            </div>
          </li>
          <li class="mb-3">
            <div class="single-settings">
              <div class="setting-left">
                <label>Display Scorecard Link In My Profile</label>
              </div>
              <div class="setting-action">
                <vs-switch v-model="settings.DisplayScorecardLinkInMyProfile" />
              </div>
            </div>
          </li>
          <li class="mb-3" v-for="(tab, index) in Tabs">
            <div class="single-settings">
              <div class="setting-left">
                <p>{{ tab.TabName }}</p>
              </div>
              <div class="setting-action">
                <span
                  ><vs-input
                    v-model="Tabs[index].DisplayLabel"
                    :class="tab.TabId == TextBoxShowingId ? 'show' : 'hidden'"
                /></span>
                <span>
                  <feather-icon
                    icon="EditIcon"
                    class="ml-2 mr-2 mt-1"
                    @click="showTextBox(tab.TabId)"
                    :class="tab.TabId == TextBoxShowingId ? 'hidden' : 'show'"
                  />
                  <feather-icon
                    icon="XCircleIcon"
                    class="ml-2 mr-2 mt-1"
                    @click="hideTextBox(tab.TabId)"
                    :class="tab.TabId == TextBoxShowingId ? 'show' : 'hidden'"
                  />
                </span>
                <span
                  ><vs-switch :color="color" v-model="Tabs[index].IsPublished"
                /></span>
              </div>
            </div>
          </li>
        </ul>
        <vs-button @click="setSettings">Save</vs-button>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo userlist-popup"
      title="User List"
      :active.sync="popupUserList"
    >
      <div
        class="
          vx-col
          flex
          justify-between
          items-end
          w-full
          text-right
          mb-5
          event-admin-popup-header
        "
      >
        <vs-input
          label="Search Attendees By Name, Email"
          class="inputx w-full md:w-6/12"
          placeholder="Enter First Name, Last Name, Full Name or Email"
          v-model="searchAttendeeText"
          v-on:keyup.enter="getAttendees"
        />
        <vs-button class="ml-2" @click="getAttendees">Search</vs-button>
        <vs-button
          class="ml-2"
          color="warning"
          type="gradient"
          @click="setuserIdList(clearAttendeeList)"
          >Clear Selected Users Scores</vs-button
        >
        <vs-button
          class="ml-2"
          color="danger"
          type="gradient"
          @click="clearAllScore('All')"
          >Clear Full Event Scores</vs-button
        >
      </div>
      <div class="flex flex-wrap">
        <div class="flex-grow">
          <div>
            <vs-table :data="attendessList">
              <template slot="thead">
                <vs-th></vs-th>
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Email</vs-th>
                <vs-th>Export</vs-th>
                <vs-th>Clear Score</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].FirstName">
                    <vs-checkbox
                      v-model="clearAttendeeList"
                      :vs-value="data[indextr].AttendeeId"
                    />
                  </vs-td>
                  <vs-td :data="data[indextr].FirstName">{{
                    data[indextr].FirstName
                  }}</vs-td>
                  <vs-td :data="data[indextr].LastName">{{
                    data[indextr].LastName
                  }}</vs-td>
                  <vs-td :data="data[indextr].Email">{{
                    data[indextr].Email
                  }}</vs-td>
                  <vs-td :data="data[indextr].AttendeeId">
                    <feather-icon
                      icon="FileIcon"
                      title="Edit Admin"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="getUserActions([data[indextr].AttendeeId])"
                    />
                  </vs-td>
                  <vs-td :data="data[indextr].AttendeeId">
                    <feather-icon
                      icon="TrashIcon"
                      title="Edit Admin"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="setuserIdList([data[indextr].AttendeeId])"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo userlist-popup"
      title="User List Hide In Leaderboard"
      :active.sync="popupUserListHIL"
    >
      <div
        class="
          vx-col
          flex
          justify-between
          items-center
          w-full
          text-right
          mb-5
          event-admin-popup-header
        "
      >
        <vs-input
          label="Search Attendees By Name, Email"
          class="inputx w-full md:w-6/12"
          placeholder="Enter First Name, Last Name, Full Name or Email"
          v-model="searchAttendeeText"
          v-on:keyup.enter="getAttendees"
        />
        <vs-button class="ml-2" @click="getAttendees">Search</vs-button>        
      </div>
      <div class="flex flex-wrap">
        <div class="flex-grow">
          <div>
            <vs-table :data="attendessList">
              <template slot="thead">
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Email</vs-th>
                <vs-th>Hide</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].FirstName">{{
                    data[indextr].FirstName
                  }}</vs-td>
                  <vs-td :data="data[indextr].LastName">{{
                    data[indextr].LastName
                  }}</vs-td>
                  <vs-td :data="data[indextr].Email">{{
                    data[indextr].Email
                  }}</vs-td>
                  <vs-td :data="data[indextr].AttendeeId">
                    <vs-switch v-model="data[indextr].HideInLeaderboard" @input="setHideInLeaderboard(data[indextr].HideInLeaderboard, data[indextr].AttendeeId)"/>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo custom-activity-wrap"
      title="Create Custom Leaderboard Activity"
      :active.sync="popupActive2"
    >
      <div class="activity-wrap">
        <vs-input
          class="w-full"
          label="Activity Name"
          v-model="activityName"
          @change="updateVal"
        />
        <vs-input
          class="w-full mt-3"
          label="Display Name"
          v-model="displayName"
        />
        <div class="score-wrap">
          <vs-input-number
            class="mr-3"
            label="Score"
            color="#4c8bf6"
            v-model="minimumScore"
          />
          <vs-input-number
            label="Max score"
            color="#4c8bf6"
            v-model="maximumScore"
          />
        </div>
        <div class="pulish-score">
          <p>Publish</p>
          <vs-switch color="#4c8bf6" v-model="publishActivity" />
        </div>
        <div class="submit-wrap mt-3" style="text-align: right">
          <vs-button
            small
            color="#4c8bf6"
            type="filled"
            @click="createCustomActivity()"
            >Submit</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo custom-activity-wrap"
      title="Upload Scores Manually"
      :active.sync="popupActive3"
    >
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn cursor-pointer"
            @click="downloadTemplate()"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Upload file</p>
            <input
              type="file"
              id="customActivity_file"
              accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)"
              type="filled"
              class="sub-btn"
              @click="readCustomActivityXL"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import XLSX from 'xlsx';
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import ls from "@/common/localStorage";

// Store Module
import moduleLeaderboardManagement from "@/store/leaderboard-management/moduleLeaderboardManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";

// Cell Renderer
import CellScore from "./cell-renderer/CellScore.vue";
import CellDisplayLabel from "./cell-renderer/CellDisplayLabel.vue";
import CellMaxScore from "./cell-renderer/CellMaxScore.vue";
import CellPublish from "./cell-renderer/CellPublish.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";


//console.log(db);
//const event_collectionName = 'sayek-dev';

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellScore,
    CellDisplayLabel,
    CellMaxScore,
    CellPublish,
    CellRendererActions,
  },
  data() {
    return {
      // AgGrid
      gridApi: null,
      gridOptions: { suppressRowClickSelection: true },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      number6: 20,
      number7: 40,
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      activityName: null,
      displayName: null,
      minimumScore: 20,
      maximumScore: 100,
      publishActivity: true,
      options: [
        { id: 1, label: "foo" },
        { id: 3, label: "Scavenger Hunt" },
        { id: 2, label: "baz" },
      ],
      selected: { id: 3, label: "Scavenger Hunt" },
      options: [
        { id: 4, label: "foo" },
        { id: 5, label: "Expo" },
        { id: 6, label: "baz" },
      ],
      selected2: { id: 5, label: "Expo" },
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          headerName: "Action Type Code",
          field: "ActionTypeCode",
          filter: true,
          //width: 60
        },
        {
          headerName: "User Actions",
          field: "ActionName",
          filter: true,
          //width: 250
        },
        {
          headerName: "Display Label",
          field: "DisplayLabel",
          cellRendererFramework: "CellDisplayLabel",
          //filter: true,
          width: 250,
        },
        {
          headerName: "Max Score",
          field: "MaxActionScore",
          cellRendererFramework: "CellMaxScore",
          /*cellRendererParams: params => {
            return { id: params.data.MaxActionScore };
          }*/
        },
        {
          headerName: "Score",
          field: "ActionScore",
          cellRendererFramework: "CellScore",
          /*cellRendererParams: params => {
            return params.data.ActionScore;
          }*/
        },
        {
          headerName: "Publish",
          field: "IsPublished",
          cellRendererFramework: "CellPublish",
          /*valueGetter: params => {
              return params.data.IsPublished;
          },
          valueSetter: params => {
              params.data.IsPublished = params.newValue;
              return true;
          }*/
          /*cellRendererParams: params => {
            return params.data.IsPublished;
          }*/
        },
        {
          headerName: "Action",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return params;
          },
          pinned: "right",
        },
      ],
      settings: {
        DisplayScoreOnProfile: false,
        DisplayScorecardLinkInMyProfile: false
      },
      Tabs: [
        {
          DisplayLabel: "Users",
          IsPublished: true,
          TabId: 1,
          TabName: "Users",
        },
        {
          DisplayLabel: "Groups",
          IsPublished: true,
          TabId: 2,
          TabName: "Groups",
        },
        {
          DisplayLabel: "My Achivements",
          IsPublished: true,
          TabId: 3,
          TabName: "My Achivements",
        },
      ],

      // Cell Renderer Components
      components: {
        CellScore,
        CellDisplayLabel,
        CellMaxScore,
        CellPublish,
        CellRendererActions,
      },
      popupUserList: false,
      popupUserListHIL: false,
      attendessList: [],
      popupActive: false,
      color: "#4c8bf6",
      switch6: true,
      searchAttendeeText: "",
      clearAttendeeList: [],
      TextBoxShowingId: null,
      userIdList: [],
      cols: [{ name: "A", key: 0 }, { name: "B", key: 1 }, { name: "C", key: 2 }],
      data: [
    [ "id",    "name", "value" ],
    [    1, "sheetjs",    7262 ],
    [    2, "js-xlsx",    6969 ]
  ]
    };
  },
  watch: {},
  computed: {
    ListData() {
      return this.$store.state.LeaderboardManagement.leaderboards;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    setHideInLeaderboard(value, AttendeeId){
      this.$vs.loading();
      this.$store.dispatch("attendeeManagement/updateHideInLeaderboard", {'HideInLeaderboard':value,'id':AttendeeId}).then(res=>{
        this.$vs.loading.close();
      })
    },
    getHideInLeaderboard(){
      this.attendessList = [];
      this.$store.dispatch("attendeeManagement/fetchHideInLeaderboardAttendees").then(res=>{
        this.attendessList = res;
        this.popupUserListHIL = true;
      });      
    },
    readCustomActivityXL(){
      let vm = this;
      var files = document.getElementById("customActivity_file").files;
      if (!files.length) {
            alert("Please Upload File!");
            return;
        } else {
            var validFileTypes = [
                ".csv",
                "csv",
                ".xlsx",
                "xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ];
            var f = files[0];
            var ext = f.name.split(".")[f.name.split(".").length - 1];
            if (!validFileTypes.includes(f.type) && !validFileTypes.includes(ext)) {
                alert("Only csv,excel file allowed.");
                return false;
            }

            var reader = new FileReader();
            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: "array" });
                let worksheet = workbook.Sheets['UserActivity'];
                if(!worksheet){ alert("Sheet Name UserActivity not Exists!"); return false; }
                let dataArray = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1                    
                });
                let activityArray = [];
                for(let i=1;i<dataArray.length;i++){
                  if(dataArray[i].length){
                    activityArray.push({
                      email: dataArray[i][0] ? dataArray[i][0] : null,
                      actionTypeCode: dataArray[i][1] ? dataArray[i][1] : null,
                      quantity: dataArray[i][2] ? dataArray[i][2] : null,
                      reverse: dataArray[i][3] ? dataArray[i][3] : false
                    })
                  }
                }
                vm.uploadCustomActivity(activityArray);
            }
            reader.readAsArrayBuffer(f);
        }
    },
    uploadCustomActivity(dataArray){
      //console.log(dataArray)
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/uploadCustomActivity", dataArray)
        .then(res => {
          this.$vs.loading.close();
          if(res.status == 200){
            this.$vs.notify({
              position: "center",
              color: 'success',
              text: `Data updated`
            })
          }
          else{
            this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Data not updated!`
            })
          }
          window.location.reload();
        }).catch(err=>{
          this.$vs.loading.close();
          this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Something went wrong!`
            })
          window.location.reload();
        })
    },
    downloadTemplate(){
      /*var data = [
        {"name":"John", "city": "Seattle"},
        {"name":"Mike", "city": "Los Angeles"},
        {"name":"Zach", "city": "New York"}
      ];*/
      let data = this.ListData;
      /* this line is only needed if you are not adding a script tag reference */
      //if(typeof XLSX == 'undefined') XLSX = require('xlsx');

      /* make the worksheet */
      let ws1 = XLSX.utils.json_to_sheet(data);

      /* add to workbook */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws1, "Activities");

      let data2 = [
        {
          "Email": null,
          "Action Type Cod": null,
          "Quantity": null,
          "Reverse": false
        }
      ]
      let ws2 = XLSX.utils.json_to_sheet(data2);
      XLSX.utils.book_append_sheet(wb, ws2, "UserActivity");

      /* generate an XLSX file */
      XLSX.writeFile(wb, "UserActivitiesBulk.xlsx");
    },
    openManualScoreUploadModal(){
      this.popupActive3 = true;
    },
    createCustomActivity() {
      this.popupActive2 = false;
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/createCustomActivity", {
          activityName: this.activityName,
          displayName: this.displayName,
          minimumScore: this.minimumScore,
          maximumScore: this.maximumScore,
          publishActivity: this.publishActivity,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.activityName = null;
          this.displayName = null;
          this.minimumScore = 20;
          this.maximumScore = 100;
          this.publishActivity = true;
          console.log("res---",res)
          if (res.status == 200) {
            this.$store.dispatch("LeaderboardManagement/fetchLeaderboards");
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "Custom Activity Created successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Custom Activity could not be created!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something Went Wrong!",
          });
        });
    },
    updateVal() {
      this.displayName = this.activityName;
    },
    showTextBox(id) {
      this.TextBoxShowingId = id;
    },
    hideTextBox(id) {
      this.TextBoxShowingId = null;
    },
    getSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/getSettings")
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.Tabs = res.data.Tabs;
            this.settings.DisplayScoreOnProfile = res.data.DisplayScoreOnProfile ? res.data.DisplayScoreOnProfile : false;
            this.settings.DisplayScorecardLinkInMyProfile = res.data.DisplayScorecardLinkInMyProfile ? res.data.DisplayScorecardLinkInMyProfile : false;
            this.popupActive = true;
          }
        })
        .catch((_) => {
          this.$vs.loading.close();
        });
    },
    setSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/setSettings", {
          Tabs: this.Tabs,
          settings: this.settings,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.popupActive = false;
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "Data Saved successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Data Not Saved!",
            });
          }
        })
        .catch((_) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something Went Wrong!",
          });
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    setuserIdList(userIdlist) {
      if (userIdlist.length) {
        this.userIdList = userIdlist;
        this.clearAllScore("Single");
      } else {
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          text: "Select User Please!",
        });
      }
    },
    clearAllScore(type) {
      this.popupUserList = false;
      const { value: text } = Swal.fire({
        title: "Do you want to Clear All Scores?",
        input: "text",
        inputPlaceholder: "Type 'clear' and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          if (value.toLocaleLowerCase().trim() == "clear") {
            if (type == "All") this.clearScoreAll();
            else this.clearItems();
          } else {
            return "Try again! Please type 'clear' and hit Submit.";
          }
        },
      });
    },
    clearItems() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/clearItems", {
          itemIds: this.userIdList,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.userIdList = [];
          this.attendessList = [];
          this.searchAttendeeText = null;
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "Scores Cleared successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Scores not Cleared!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something Went Wrong!",
          });
        });
    },
    clearScoreAll() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/clearScore")
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "All Scores Cleared successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Scores not Cleared!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something Went Wrong!",
          });
        });
    },
    getAttendees() {
      if (this.searchAttendeeText) {
        this.attendessList = [];
        this.$store
          .dispatch("attendeeManagement/searchAttendeesApi", {
            value: this.searchAttendeeText,
          })
          .then((res) => {
            //this.attendessList = res;
            if (res.status == 200) {              
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].IsPublished) {
                  this.attendessList.push({
                    AttendeeId: res.data[i].AttendeeId,
                    Email: res.data[i].Email,
                    FirstName: res.data[i].FirstName
                      ? res.data[i].FirstName
                      : "",
                    LastName: res.data[i].LastName ? res.data[i].LastName : "",
                    Name: res.data[i].Name ? res.data[i].Name : "",
                    HideInLeaderboard: res.data[i].HideInLeaderboard ? res.data[i].HideInLeaderboard : false
                  });
                }
              }
            }
          });
      }
    },
    getUserActions(uid) {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/getUserActions", uid)
        .then((selectedRows) => {
          this.$vs.loading.close();
          if (selectedRows.Achievements.LeaderActions.length > 0) {
            var datarow = [];
            datarow.push("Name");
            datarow.push("Type");
            datarow.push("My Activity Count");
            datarow.push("UserName");
            datarow.push("Score");
            var AttendeeData = [];
            AttendeeData.push(datarow);
            selectedRows.Achievements.LeaderActions.forEach((row) => {
              datarow = [];
              datarow.push('"' + row.Name + '"');
              datarow.push('"' + row.Type + '"');
              datarow.push('"' + row.IPCount + '"');
              datarow.push('"' + row.UserName + '"');
              datarow.push('"' + row.Score + '"');
              AttendeeData.push(datarow);
            });

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "leaderboardUsersActionsExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        });
    },
    exportAllUsers() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/exportAllUsers")
        .then((selectedRows) => {
          this.$vs.loading.close();
          if (selectedRows.length > 0) {
            var datarow = [];
            datarow.push("Name");
            datarow.push("Email");
            datarow.push("Score");
            var AttendeeData = [];
            AttendeeData.push(datarow);
            selectedRows.filter((row) => {
              datarow = [];
              var Name =
                row.Name == undefined ? "" : row.Name.replace(/\"/g, '""');
              datarow.push('"' + Name + '"');
              datarow.push('"' + row.Email + '"');
              datarow.push('"' + row.Score + '"');
              AttendeeData.push(datarow);
            });

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "leaderboardAllUsersExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        });
    },
    exportAllActions() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/exportAllActions")
        .then((selectedRows) => {
          this.$vs.loading.close();
          if (selectedRows.length > 0) {
            var datarow = [];
            datarow.push("Code");
            datarow.push("Label");
            datarow.push("Name");
            datarow.push("Email");
            datarow.push("Score");
            var AttendeeData = [];
            AttendeeData.push(datarow);
            selectedRows.filter((row) => {                 
              row.Users.filter(u=>{
                datarow = [];
                datarow.push('"' + row.Code + '"');
                datarow.push('"' + row.Label + '"');

                datarow.push('"' + u.Name + '"');
                datarow.push('"' + u.Email + '"');
                datarow.push('"' + u.Score + '"');

                AttendeeData.push(datarow);
              })              
            });

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "leaderboardAllActionsExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        });
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleLeaderboardManagement.isRegistered) {
      this.$store.registerModule(
        "LeaderboardManagement",
        moduleLeaderboardManagement
      );
      moduleLeaderboardManagement.isRegistered = true;
    }
    this.$store.dispatch("LeaderboardManagement/fetchLeaderboards");
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>